// @flow

/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import {
  Typography,
  Container,
  Fab,
  Box,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

/* -----------------Assets--------------- */
import PartnerLogos from '@images/illustrations/partner_logos.png';

/* -----------------Styles--------------- */

const styles = theme => ({
  fab: {
    padding: theme.spacing(4),
    borderRadius: 40,
    fontSize: 18,
  },
  image: {
    maxHeight: 150,
    maxWidth: '100%',
  },
});

/* -----------------Type declarations--------------- */
type Classes = {
  fab: string,
  image: string,
}

/* -----------------Props--------------- */
type Props = {
  classes: Classes,
};

/* -----------------Component--------------- */

const PartnersBanner = (props: Props) => {
  const {
    classes,
  } = props;
  const title = 'Want to partner with Memorang?';
  const description = 'We work with major publishers, universities, professional organizations, tutoring companies, and even individual authors';
  const path = '/partners';
  const cta = '👉 Learn More';
  const image = PartnerLogos;
  return (
    <Box
      py={12}
      textAlign="center"
      bgcolor="grey.800"
      color="common.white"
    >
      <Container maxWidth="lg">
        <Box pb={4}>
          <Typography variant="h4">
            {title}
          </Typography>
        </Box>
        <Typography variant="body1">{description}</Typography>
        <Box pt={4} pb={6}>
          <Fab
            href={path}
            classes={{ root: classes.fab }}
            color="primary"
            variant="extended"
          >
            {cta}
          </Fab>
        </Box>
        <Box>
          <img src={image} className={classes.image} alt="Partner Logos" />
        </Box>
      </Container>
    </Box>
  );
};

export default withStyles(styles)(PartnersBanner);
